export default "__VITE_ASSET__BiaNacK0__"